import { render } from "./DishDetail.vue?vue&type=template&id=4a4a1134&scoped=true"
import script from "./DishDetail.vue?vue&type=script&lang=js"
export * from "./DishDetail.vue?vue&type=script&lang=js"

import "./DishDetail.vue?vue&type=style&index=0&id=4a4a1134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4a1134"]])

export default __exports__